import CustomPdfInput from "components/CustomPdfInput";
import { useEffect } from "react";
import { useDataProvider } from "react-admin";
import { useField } from "react-final-form";
import { isValidUrl } from "../tools";

interface IPdfInputField {
  id: string;
  uploadProgress: number;
}

const CcaReadmePdfInput = ({ uploadProgress, id }: IPdfInputField) => {
  const provider = useDataProvider();
  const ccaReadmePdfUrlField = useField("ccaReadmePdfUrl");

  useEffect(() => {
    if (
      ccaReadmePdfUrlField.input.value &&
      !isValidUrl(ccaReadmePdfUrlField.input.value)
    ) {
      provider.customGetOne(`schools/${id}`).then(({ data }: any) => {
        ccaReadmePdfUrlField.input.onChange(data.ccaReadmePdfUrl);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ccaReadmePdfUrlField.input.value]);

  return (
    <CustomPdfInput
      label="CCA Readme (PDF)"
      source="ccaReadmePdfFile"
      urlSource="ccaReadmePdfUrl"
      uploadProgress={uploadProgress}
      maxSize={15000000}
      isRequired={true}
    />
  );
};

export default CcaReadmePdfInput;
